module.exports = __webpack_public_path__ + "static/media/bartender.aacb3d11.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/img/bartender.jpeg
// module id = 205
// module chunks = 0